import Vue from 'vue'
import './variables.scss'
import { Button, Icon } from 'element-ui'

Vue.use(Button)
Vue.use(Icon)
